<template lang="pug">
.Input._TagsWrap
   ._Tag._flex._flex-alignItemsCenter(v-for="tag in value")
      ._pl05._py025 {{tag}}
      button.Btn--blank._TagBtnRemove._fs-2(
         type="button" 
         @click="removeTag(tag)"
      ) 
         ._TagBtnRemove-inner._px025._radius &times;
   input._TagsInput(
      ref="tagInput"
      placeholder="Add tag..." 
      @keydown.enter.prevent="addTag" 
      v-model.trim="newTag"
   )
</template>

<style lang="sass" scoped>
._TagsWrap
   display: flex
   flex-wrap: wrap
   +px($s-05)
   +py($s-05)
   padding-bottom: 0
   
._Tag
   // yellow
   // background-color: $yellow-vivid-100
   // border: solid 1px $yellow-vivid-200
   // color: $yellow-vivid-900
   // blue
   background-color: $light-blue-vivid-100
   border: solid 1px $light-blue-vivid-200
   color: $light-blue-vivid-900
   border-radius: $radius
   margin-right: $s-05
   margin-bottom: $s-05
   cursor: default
   overflow: hidden
   &:last-of-type
      margin-right: 0

._TagBtnRemove
   line-height: 1
   padding-left: 3px
   padding-right: $s-025
   align-self: stretch
   &:first-child
      margin-right: 0.25rem
   &:hover 
      ._TagBtnRemove-inner
         // yellow
         // color: $yellow-vivid-800
         // background-color: $yellow-vivid-200
         // color: $yellow-vivid-900
         // blue
         color: $light-blue-vivid-800
         background-color: $light-blue-vivid-200
         color: $light-blue-vivid-900
   
._TagsInput
   flex: 1
   outline: 0
   // +py($s-05)
   margin-bottom: $s-05
   margin-left: $s-05
   min-width: 10rem
</style>

<script>
export default {
   props: ['value'],
   data() {
      return {
         newTag: '',
      }
   },
   methods: {
      addTag() {
         if (this.newTag.length === 0 || this.value.includes(this.newTag)) {
            return
         }
         this.$emit('input', [...this.value, this.newTag])
         this.newTag = ''
      },
      removeTag(tag) {
         this.$emit('input', this.value.filter(t => t !== tag))
         this.$nextTick(() => this.$refs.tagInput.focus())
      },
   },
   mounted() {
      console.log(this.value)
   },
}
</script>
